// extracted by mini-css-extract-plugin
export default {"videoPreview":"vUYAs","active":"ul2cy","posterImage":"S96zP","playIcon":"IVXV_","cnImage":"JjYIN","container":"A6lqt","video":"Un9oV"};